// extracted by mini-css-extract-plugin
module.exports = {"navigation__item":"navigation-module--navigation__item--o8L3K","header":"navigation-module--header--dKUmu"};